<svg viewBox="0 0 32 32" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M30 24.828l-9.974-8.16L16 19.62l-4.026-2.953L2 24.827V26h28v-1.172zm0-1.292V9.353l-9.141 6.704L30 23.536zm-28 0l9.141-7.48L2 9.354v14.183zM2 8.113L16 18.38 30 8.113V7H2v1.113zM2 5h28a2 2 0 0 1 2 2v19a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"/>
</svg>
